import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDynamicDateMaxLength]'
})
export class DynamicDateMaxLengthDirective implements AfterViewInit {

  private initMaxLength = 10;
  private baseMaxLength = 8;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    this.renderer.setAttribute(this.elementRef.nativeElement, "maxLength", String(this.initMaxLength));
  }


  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    value = value ?? "";
    const dotCount = (value.match(/\./g) || []).length;
    const maxLength = dotCount !== 0 ? this.initMaxLength : this.baseMaxLength;
    this.renderer.setAttribute(this.elementRef.nativeElement, "maxLength", String(maxLength > this.initMaxLength ? this.initMaxLength : maxLength));
  }
}
